import React from 'react';
import Modal from '~/components/Modal';
import { WarningModalContentStyled } from './WarningModalStyled';
import { CloseThin } from '../Icons/fill';
import { Warning } from '../Icons/outline';

interface WarningModalProps {
  visible: boolean;
  onClose: () => void;
  onProceed: () => void;
  headerText: string;
  subheaderText: string;
  buttonText: string;
}

const WarningModal: React.FC<WarningModalProps> = ({
  visible,
  onClose,
  onProceed,
  headerText,
  subheaderText,
  buttonText,
}) => {
  return (
    <Modal visible={visible} handleOnClose={onClose}>
      <WarningModalContentStyled>
        <Warning id="warning-icon" />
        <CloseThin className="close-btn" role="button" tabIndex={0} onClick={() => onClose()} />
        <p className="header">{headerText}</p>
        <p className="subheader">{subheaderText}</p>
        <button onClick={onProceed}>{buttonText}</button>
      </WarningModalContentStyled>
    </Modal>
  );
};

WarningModal.displayName = 'WarningModal';

export default WarningModal;
